export { default } from './Post';



// WEBPACK FOOTER //
// ./src/components/Post/index.js